// removed by extract-text-webpack-plugin
module.exports = {"row":"src-components-Messages-Blasts-__chip__row--uwZ_G","info":"src-components-Messages-Blasts-__chip__info--2jotj","selected":"src-components-Messages-Blasts-__chip__selected--zN-dA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/Blasts/chip.css
// module id = 773
// module chunks = 0